import { ChangeDetectionStrategy, Component, forwardRef, input } from '@angular/core';
import { SlotComponent } from '../slot.component';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ComponentsModule } from '../../../../../lib';
import { AsyncPipe } from '@angular/common';
import { DelayDisplayImpurePipe, SlotTooltipPipe, TranslationKeyPipe } from '../../../pipes';
import { VisualComponent } from '../../visual/visual.component';

@Component({
    selector: 'ca-slot-multiselect-dropdown',
    imports: [ComponentsModule, AsyncPipe, TranslationKeyPipe, VisualComponent, SlotTooltipPipe, DelayDisplayImpurePipe],
    templateUrl: './slot-multiselect-dropdown.component.html',
    styleUrl: './slot-multiselect-dropdown.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SlotMultiselectDropdownComponent),
            multi: true
        }
    ]
})
export class SlotMultiselectDropdownComponent extends SlotComponent {
    ariaLabel = input<string>('');

    override writeValue(value: any): void {
        this.value.set(value);
    }

    onValueChange(value: any) {
        if (!this.isDisabled) {
            this.value.set(value);
            this.onChange(value);
        }
    }
}
